/* ===== Constructor de packs · Vista rápida ===== */
(() => {
  if (window.BundleQuickView) return;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cache = new Map();

  function bindDialog(dialog) {
    if (dialog.bbBound) return;
    dialog.bbBound = true;
    dialog.querySelector('[data-bb-qv-close]')?.addEventListener('click', () => dialog.close());
    // Cerrar al pulsar fuera del contenido (sobre el fondo)
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
  }

  window.BundleQuickView = {
    async open(card, builder) {
      const handle = card.dataset.handle;
      const productUrl = `${ROOT}products/${handle}`;
      const dialog = builder.root.querySelector('[data-bb-qv]');

      if (!dialog || typeof dialog.showModal !== 'function') {
        window.location.href = productUrl;
        return;
      }
      bindDialog(dialog);

      const content = dialog.querySelector('[data-bb-qv-content]');
      const hint = dialog.querySelector('[data-bb-qv-hint]');
      const addBtn = dialog.querySelector('[data-bb-qv-add]');

      hint.textContent = '';
      content.replaceChildren();
      dialog.classList.add('is-loading');
      dialog.showModal();

      try {
        let html = cache.get(handle);
        if (!html) {
          const res = await fetch(`${productUrl}?section_id=ss-bundle-quick-view`);
          if (!res.ok) throw new Error('Quick view no disponible');
          html = await res.text();
          cache.set(handle, html);
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const product = doc.querySelector('[data-bb-qv-product]');
        if (!product) throw new Error('Quick view vacía');
        content.replaceChildren(document.importNode(product, true));
      } catch (e) {
        dialog.close();
        window.location.href = productUrl;
        return;
      }

      dialog.classList.remove('is-loading');

      const link = content.querySelector('[data-bb-qv-link]');
      if (link) link.textContent = builder.t.qvLink || '';

      // Tallas: sincronizadas con la tarjeta
      let selected = card.bbSelected;
      const sizes = [...content.querySelectorAll('[data-bb-qv-size]')];

      const markSelected = () => {
        sizes.forEach((b) => {
          const active = b.dataset.variantId === selected;
          b.classList.toggle('is-selected', active);
          b.setAttribute('aria-pressed', String(active));
          b.classList.toggle('has-qty', builder.qtyOf(b.dataset.variantId) > 0);
        });
      };
      markSelected();

      sizes.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          selected = btn.dataset.variantId;
          hint.textContent = '';
          markSelected();
          const cardBtn = card.querySelector(`button[data-bb-size][data-variant-id="${selected}"]`);
          if (cardBtn) builder.selectSize(card, cardBtn);
        });
      });

      addBtn.onclick = () => {
        if (!selected) {
          hint.textContent = builder.t.chooseSize || '';
          sizes.find((b) => !b.disabled)?.focus();
          return;
        }
        builder.add(selected);
        dialog.close();
      };

      dialog.querySelector('[data-bb-qv-close]')?.focus();
    },
  };
})();